import useMediaQuery from "@mui/material/useMediaQuery";

export const useDeviceDetect = () => {
    const isMobile = useMediaQuery("(max-width:480px)");
    const isTablet = useMediaQuery("(max-width:1023px)");
    const isDesktop = useMediaQuery("(min-width:1024px)");

    return { isMobile, isTablet, isDesktop };
};
